const backendPrefix = '/api/';
const frontendPrefix = '/';

// eslint-disable-next-line
export const others = {
  users: {
    backend: `${backendPrefix}core/user/`,
    frontend: `${frontendPrefix}users/`,
  },
  profiles: {
    backend: `${backendPrefix}core/profiles/`,
    frontend: `${frontendPrefix}profiles/`,
  },
};

export default others;
